// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + "db98d49ee5d47fdcf9e6" + ".css";
};